/**
 * Handles chunk loading errors by automatically refreshing the page.
 * This typically happens after a new deployment when cached chunks become outdated.
 */
export const handleChunkLoadError = () => {
  window.addEventListener('error', (event) => {
    const target = event.target || event.srcElement;
    const isChunkLoadError = event.message && (
      event.message.includes('Loading chunk') || 
      event.message.includes('Loading CSS chunk') ||
      event.message.includes('module not found')
    );
    
    // Check if the error is related to chunk loading
    if (isChunkLoadError || (target && target.tagName === 'LINK' && target.href && target.href.includes('.chunk.'))) {
      console.log('Detected chunk loading error. Refreshing page...');
      
      // Clear cache and reload page
      if ('caches' in window) {
        caches.keys().then((names) => {
          names.forEach(name => {
            caches.delete(name);
          });
        });
      }
      // Add a timestamp parameter to force a fresh reload
      window.location.reload(true);
    }
  }, false);
};